/**
 * 用户相关接口
 */

import { get } from '@fe/common/lib/ajax';

/**
 * 获取用户当前企业生效的套餐
 * @param {string} organizeId 企业id
 */
export async function getOrgPackage(organizeId) {
  return await get(`/api/store/user/orgPackage`, { organizeId });
}

/**
 * 获取用户是否开通小游戏
 */
// export async function getUserGameAuth() {
//   return await get('/api/store/game/getUserPrototype');
// }

/**
 * 获取用户是否有引流标签
 */
export async function getMobileCollect() {
  return await get('/api/store/template/getMobileTag');
}
